import { Pipe, PipeTransform } from '@angular/core';
import { Question } from './question';

@Pipe({
    name: 'questionfilter',
    pure: false
})

export class QuestionFilterPipe implements PipeTransform {
    transform(items: Question[], filter: Question): Question[] {
        if (!items || !filter) {
          return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter((item: Question) => this.applyFilter(item, filter));
    }

    applyFilter(book: Question, filter: Question): boolean {
        for (let field in filter) {
          if (filter[field]) {
            if (typeof filter[field] === 'string') {
              if (book[field].toLowerCase().indexOf(filter[field].toLowerCase()) === -1) {
                return false;
              }
            } else if (typeof filter[field] === 'number') {
              if (book[field] !== filter[field]) {
                return false;
              }
            }
          }
        }
        return true;
      }
}